import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AvatarModule } from '@y42/core/avatar';
import { LogoLoaderModule } from '@y42/core/logo-loader';
import { SmartBtnModule } from '@y42/core/smart-btn';
import { IntercomModule } from '@y42/intercom';
import { GitStashedChangesButtonModule } from '../git-stashed-changes-button';
import { GitCommitDialogComponent } from './git-commit-dialog.component';
import { GitCommitPreviewModule } from './git-commit-preview/git-commit-preview.module';

@NgModule({
  declarations: [GitCommitDialogComponent],
  exports: [GitCommitDialogComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatInputModule,
    A11yModule,
    LogoLoaderModule,
    SmartBtnModule,
    MatRadioModule,
    GitStashedChangesButtonModule,
    IntercomModule,
    FontAwesomeModule,
    GitCommitPreviewModule,
    AvatarModule,
    MatTooltipModule,
  ],
})
export class GitCommitDialogModule {}
